import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const client = axios.create({ baseURL: API });

client.interceptors.request.use((config) => {
  const token = localStorage.getItem("frb_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export default client;

export const authApi = {
  signup: (data) => client.post("/auth/signup", data).then((r) => r.data),
  login: (data) => client.post("/auth/login", data).then((r) => r.data),
  me: () => client.get("/me").then((r) => r.data),
};

export const bankApi = {
  accounts: () => client.get("/accounts").then((r) => r.data),
  transfer: (data) => client.post("/transfers", data).then((r) => r.data),
  payFee: (txId, from_account = "checking") =>
    client.post(`/transfers/${txId}/pay_fee`, { from_account }).then((r) => r.data),
  transactions: () => client.get("/transactions").then((r) => r.data),
};

export const formatMoney = (n) =>
  new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "USD",
    maximumFractionDigits: 2,
  }).format(Number(n || 0));

export const formatMoneyShort = (n) => {
  const v = Number(n || 0);
  if (v >= 1_000_000) return `$${(v / 1_000_000).toFixed(2)}M`;
  if (v >= 1_000) return `$${(v / 1_000).toFixed(1)}K`;
  return `$${v.toFixed(2)}`;
};
